<template>
  <div class="child-tracking-system-default">
    <div class="row">
      <div class="col-12 text-center text-sm-start">
        <span class="d-none d-sm-block">
          <page-title
            :title="'Kindvolgsysteem'" 
            icon="childtrackingsystem"
          />
        </span>
        <span class="d-block d-sm-none">
          <page-title
            :title="'Kindvolgsysteem'" 
            icon="childtrackingsystem"
          />
        </span>
      </div>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/childtrackingsystem/analyse'"
            active="true"
            exact-active-class="active"
          >
            <span class="d-none d-sm-block">Observeren</span><span class="d-block d-sm-none">O</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/childtrackingsystem/results'"
            exact-active-class="active"
          >
            <span class="d-none d-sm-block">Resultaten</span><span class="d-block d-sm-none">R</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/childtrackingsystem/forms'"
            exact-active-class="active"
          >
            <span class="d-none d-sm-block">Observatieformulieren</span><span class="d-block d-sm-none">F</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
              class="nav-link"
              :to="'/childtrackingsystem/groupOverview'"
              exact-active-class="active"
          >
            <span class="d-none d-sm-block">Groepsoverzicht</span><span class="d-block d-sm-none">G</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
              class="nav-link"
              :to="'/childtrackingsystem/parentContact'"
              exact-active-class="active"
          >
            <span class="d-none d-sm-block">Notities</span><span class="d-block d-sm-none">N</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/childtrackingsystem/triggers'"
            exact-active-class="active"
          >
            <span class="d-none d-sm-block">Herinneringen</span><span class="d-block d-sm-none">H</span>
          </router-link>
        </li>
<!--        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/childtrackingsystem/grafic'"
            exact-active-class="active"
          >
            <span class="d-none d-sm-block">Grafiek</span><span class="d-block d-sm-none">G</span>
          </router-link>
        </li>-->
      </ul>
    </div>
    <div>
        <router-view />
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
export default {
  name: 'ChildTrackingSystemDefault',
  components: {PageTitle},
  data() {
    return {
      results: []
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
    .nav-tabs .nav-item.show .nav-link,
    .nav-tabs .nav-link,
    .nav-tabs .nav-link.active,
    .nav-tabs .nav-link:hover,
    .nav-tabs li,
    .nav-tabs li:hover {
      border: 0;
      border-color: white;
      border-radius: 0;
      margin-right: 0;
    }
    .nav-tabs>li>a,
    .nav-tabs>li>a.active {
      padding: 19px;
      padding-left: 20px;
      padding-right: 20px;
      background-color: #dedee7;
      border: 1px solid #cecece;
    }
    .nav-tabs>li>a:hover,
    .nav-tabs>li>a.active {
      background-color: white;
    }
    .nav-tabs>li>a,
    .nav-tabs>li.active>a,
    .nav-tabs>li.active>a:hover,
    .nav-tabs>li.active>a:focus,
    .nav>li>a:hover,
    .nav>li>a:focus,
    #children-wrapper .child:hover,
    .nav-tabs {
      border: 0;
      color: #445161;
      font-weight: 500;
      font-size: 18px;
    }

</style>
